import OdometerView from './containers/OdometerView';
import React from 'react';

export default OdometerView;

export {uiDataOdometerView} from './reducers/OdometerView';